// src/services/wishlistService.js
import { orderApi } from '../utils/apiConfig';

export const wishlistService = {
  getWishlist: async () => {
    const response = await orderApi.get('/api/v1/wishlist');
    return response.data;
  },
  addToWishlist: async (outletVariantId) => {
    const response = await orderApi.post(`/api/v1/wishlist/add/${outletVariantId}`);
    return response.data;
  },
  removeFromWishlist: async (outletVariantId) => {
    const response = await orderApi.delete(`/api/v1/wishlist/remove/${outletVariantId}`);
    return response.data;
  }
};